// extracted by mini-css-extract-plugin
export default {"instructor_name":"InstructorName_instructor_name__nVm5k"};